import React from "react";

export const SingleColumnDiv = ({ children }) => {
  return (
    <div className="flex flex-col w-full mb-4">
      {children}
    </div>
  )
};
